/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(() =>
{
  window.addEventListener('load', () =>
  {
    // Modal
    document.querySelectorAll('[data-modal-toggle]').forEach((item) =>
    {
      item.addEventListener('click', () =>
      {
        document.querySelector(item.dataset.modalToggle).classList.toggle('active');
      });
    });

    // Custom links behaviour
    document.querySelectorAll('[href="#size-general"]').forEach((item) =>
    {
      item.addEventListener('click', (e) =>
      {
        e.preventDefault();

        const id = item.href.split('#');
        document.querySelector(`#${id[id.length - 1]}`).classList.toggle('active');
      });
    });
  });

  // Videos autoplay
  const video_observer = new IntersectionObserver((entries) => entries.forEach(entry =>
  {
    entry.isIntersecting ? entry.target.play() : entry.target.pause();
  }));

  document.querySelectorAll('video:not([data-manual])').forEach((item) => video_observer.observe(item));

  const video_active_class = 'video--active';

  document.querySelectorAll('video[data-manual]').forEach((item) =>
  {
    const parent = item.parentElement;
    const video = parent.querySelector('video');

    parent.addEventListener('click', (e) =>
    {
      e.preventDefault();

      if (parent.classList.contains(video_active_class))
      {
        video.pause();
        parent.classList.remove(video_active_class);
      }
      else
      {
        video.play();
        parent.classList.add(video_active_class);
      }
    });
  });
})();